export const APP_CONFIG = {
  appPrefix: 'app',
  version: '1.0.1',
  auth: 'pass3', // Use pass2 if your app uses old version of pass
  i18n: {
    defaultLanguage: 'en',
    version: '1.0.1',
    countries: {
      enabled: false, // Set to true if your app uses countries picker
      useCountryLanguages: false, // Set to true if you want to use country languages
      list: [] // Add list of available countries
    },
    languages: {
      enabled: true, // Set to false if your app uses country languages
      list: [
        'da',
        'en_US',
        'es_US',
        'be',
        'bg',
        'cs',
        'da',
        'de',
        'el',
        'en',
        'es',
        'et',
        'fi',
        'fr',
        'hr',
        'hu',
        'it',
        'lt',
        'lv',
        'nb',
        'nl',
        'np',
        'pl',
        'pt',
        'ro',
        'ru',
        'sk',
        'sl',
        'sr',
        'sv'
      ] // Add list of available languages
    }
  }
};



// WEBPACK FOOTER //
// ./src/config/settings.ts